import React from 'react';
import ActionsToolBar from './ActionsToolBar/ActionsToolBar';
import MainToolBar from './MainToolBar/MainToolBar';
import useObservable from '../../../../../Shared/Hooks/useObservable.Hook';
import { getSelectedItems } from '../../../../Services/SelectedItems.service';

const ToolBarWrapper = () => {
  const [error1, selectedItems]: any = useObservable(getSelectedItems());

  return (
    <>
      {selectedItems && selectedItems.length > 0 ? (
        <ActionsToolBar />
      ) : (
        <MainToolBar />
      )}
    </>
  );
};

export default ToolBarWrapper;
